// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3dgEN","range":"MonthRangeSwitch_range__-KE_w","disabled":"MonthRangeSwitch_disabled__IaL1p"};